import { Stack } from '@cheqroom/ui';
import { getBleed } from '@cheqroom/ui/util';
import tw, { styled } from 'twin.macro';

export const StyledWorkspacesList = styled(Stack)`
	${tw`max-h-[222px] overflow-auto`}
	${getBleed(4)}
`;
